import React, { useState } from "react";
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import i18n from 'utils/i18n'
import Form, { createTranslationField } from 'components/molecules/Form'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import HelperDate, { dateFormat } from 'utils/helper-date'

const AppMessageData = ({ appMessage, saveForm }) => {
	
	const appMessageDateRange = {
		startDate: HelperDate.date( appMessage?.date_start, dateFormat.DATE ).toDate(),
		endDate: HelperDate.date( appMessage?.date_end, dateFormat.DATE ).toDate()
	}
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	const [ selectedDate, setSelectedDate ] = useState( !_.isEmpty( appMessage?.date_start ) ? appMessageDateRange : HelperDate.defaultDateRange() )
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const formFields = [
		{
			name: 'dates',
			label: i18n.t('management:form.time.title'),
			type: FormFieldsConstants.DATE_RANGED_PICKER,
			range: selectedDate,
			onSelect: setSelectedDate
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	];
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			
			const languageContents = _.filter( appMessage.translations ?? [], ( o => {
				return o.language.code === language.code
			}) );
			
			formFields.push( {
				type: FormFieldsConstants.DIVIDER
			} );
			
			_.forEach([ 'title', 'description'], field => {
				const { name, formField } = createTranslationField( field, language );
				
				formFields.push({
					...formField,
					type: field !== 'description' ? FormFieldsConstants.TEXT : FormFieldsConstants.TEXT_AREA,
					props: field !== 'description' ? {} : {
						numberOfLines: 5
					},
				});
				
				if( !_.isEmpty( languageContents ) ) {
					appMessage[ name ] = _.find( languageContents, { field: field } )?.[ field ] ?? '';
				}
			})
		});
	}
	
	const onSaveForm = ( values, ...props ) => {
		// Update the dates
		values[ 'dates' ] = selectedDate
		values[ 'date_start' ] = HelperDate.date( selectedDate[ 0 ] ).format( dateFormat.DATE )
		values[ 'date_end' ] = HelperDate.date( selectedDate[ 1 ] ).format( dateFormat.DATE )

		saveForm( values, ...props )
	}
	
	return (
		<ThemedBlock
			header={ i18n.t('management:form_block.title_default') }
			shadow
			mediumPadding>
			
			{/* Form */}
			<Form
				key={ HelperString.hash( 'form', formKey ) }
				values={ appMessage }
				fields={ formFields }
				onSubmit={ onSaveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.MESSAGES ) }
			/>
		</ThemedBlock>
	)
}

export default AppMessageData
